module.exports = __webpack_public_path__ + "img/portaal-logo.d227fe3c.png";